'use strict';

var Actions = require('../actions/InvitationServerActionCreators'),
    { get: get, put, post } = require('../utils/APIUtils');

var InvitationAPI = {
  requestInvitationsPage(url) {
    url = url || '/api/invites';
    get(url, Actions.handleInvitationsPage);
  },

  requestSocialFriendsPage(serviceType, url) {
    url = url || '/api/user/services/' + serviceType.toLowerCase() + '/friends';
    get(url, Actions.handleSocialFriendsPage, serviceType);
  },

  sendInvite(invite) {
    post('/api/invites', invite, Actions.handleSendInvite);
  },

  resendInvite(inviteId) {
    post('/api/invites/' + inviteId + '/resend', Actions.handleResendInvite);
  },

  updateInvite(invite) {
    put('/api/invites/' + invite.id, {status: 'SENT'}, Actions.handleUpdateInvite);
  }
};

module.exports = InvitationAPI;


/** WEBPACK FOOTER **
 ** ./api/InvitationAPI.js
 **/